/* eslint-disable no-prototype-builtins */
import { useContext, useRef, useState } from "react";
import Select from "react-select";

import { RadioGroup } from "@headlessui/react";

import { GrantsAndIncentivesContext } from "common/contexts";

import ButtonNew from "components/atoms/ButtonNew/index";
import { IoChevronDown } from "components/atoms/Icon/io5/IoChevronDown";

import styles from "../Index.module.scss";

const customStyles = {
  container: (provided) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    color: "#333",
    borderRadius: 10,
    padding: "16px 24px",
    lineHeight: "26px",
    borderWidth: "0.5px",
    borderColor: "#007EFF !important",
    boxShadow: "none",
    fontWeight: "500",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 10,
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    color: state.isRegistered ? "#007eff" : "#333",
    background: state.isRegistered || state.isFocused ? "#F1FBFF" : "",
    fontWeight: state.isRegistered ? "600" : "normal",
  }),
  placeholder: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    color: "#333",
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    lineHeight: "26px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "0px",
  }),
};
const registeredOptions = [
  {
    name: "Yes",
    value: true,
  },
  {
    name: "No",
    value: false,
  },
];

function Step2({ data }) {
  const { setStep, dataStep2, setDataStep2 } = useContext(
    GrantsAndIncentivesContext
  );
  const {
    years_operation,
    business_size,
    local_shareholding,
    number_employees,
    country_id,
  } = data;
  const companyNameRef = useRef();
  const [registered, setRegistered] = useState(
    dataStep2.country_id ? dataStep2.country_id === 191 : null
  );
  const [rerender, setRerender] = useState(false);
  // Const handleOnChangeStep = () => {
  //   SetDataStep2((prev) => ({
  //     ...prev,
  //     Company_name: companyNameRef.current.value,
  //     Sg_registered: registered,
  //   }));
  // };

  return (
    <>
      <div className={`${styles.step2} relative z-30`}>
        <div className="mb-10">
          <p className={`${styles.title}`}>Your company name</p>
          <input
            id="company_name"
            ref={companyNameRef}
            className={`${styles.companyName}`}
            placeholder="Company name"
            defaultValue={dataStep2.company_name}
            onChange={(e) => {
              setTimeout(() => {
                setDataStep2((prev) => ({
                  ...prev,
                  company_name: e.target.value,
                }));
              }, 300);
            }}
          />
        </div>

        <div className="mb-10">
          <p className={`${styles.title}`}>Registered in Singapore?</p>
          <RadioGroup
            value={registered}
            onChange={(value) => {
              setDataStep2((prev) => ({
                ...prev,
                country_id: value ? country_id : 2,
              }));
              setRegistered(value);
            }}
          >
            <div className="space-y-2">
              {registeredOptions.map((plan) => (
                <RadioGroup.Option
                  key={plan.name}
                  value={plan.value}
                  className={({ checked }) =>
                    `
                    transition-colors duration-150
                  ${checked ? "bg-bbc-brand-500 text-white" : "bg-white"}
                    relative flex cursor-pointer rounded-lg border border-bbc-brand-500 px-6 py-4 focus:outline-none focus:ring-0`
                  }
                >
                  {({ checked }) => (
                    <>
                      <RadioGroup.Label
                        as="p"
                        className={`font-medium leading-bbc-26  ${
                          checked ? "text-white" : "text-gray-900"
                        }`}
                      >
                        {plan.name}
                      </RadioGroup.Label>
                    </>
                  )}
                </RadioGroup.Option>
              ))}
            </div>
          </RadioGroup>
        </div>

        <div className="mb-10">
          <p className={`${styles.title}`}>Years in operation</p>
          <Select
            defaultValue={dataStep2.years_operation_hold}
            options={years_operation}
            isSearchable={false}
            inputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              IndicatorsContainer: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
            }}
            onChange={(value) => {
              setDataStep2((prev) => ({
                ...prev,
                years_operation_hold: value,
                years_operation: value.value,
              }));
            }}
          />
        </div>
        <div className="mb-10">
          <p className={`${styles.title}`}>Annual turnover in SGD</p>
          <Select
            defaultValue={dataStep2.business_size_hold}
            isClearable={true}
            options={business_size}
            isSearchable={false}
            inputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              DropdownIndicator: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
            }}
            onChange={(value) => {
              if (value) {
                setDataStep2((prev) => ({
                  ...prev,
                  business_size_hold: value,
                  business_size: value.value,
                }));
              } else {
                const temp = dataStep2;

                delete temp.business_size_hold;
                delete temp.business_size;
                setDataStep2(temp);
                setRerender(!rerender);
              }
            }}
          />
        </div>
        <div className="mb-10">
          <p className={`${styles.title}`}>Number of employees</p>
          <Select
            defaultValue={dataStep2.number_employees_hold}
            isClearable={true}
            options={number_employees}
            isSearchable={false}
            inputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              DropdownIndicator: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
            }}
            onChange={(value) => {
              if (value) {
                setDataStep2((prev) => ({
                  ...prev,
                  number_employees_hold: value,
                  number_employees: value.value,
                }));
              } else {
                const temp = dataStep2;

                delete temp.number_employees_hold;
                delete temp.number_employees;
                setDataStep2(temp);
                setRerender(!rerender);
              }
            }}
          />
        </div>
        <div className="mb-10">
          <p className={`${styles.title}`}>
            % local shareholding by Singaporean or Permanent Resident (PR)
          </p>
          <Select
            defaultValue={dataStep2.local_shareholding_hold}
            options={local_shareholding}
            isSearchable={false}
            inputMode="search"
            placeholder={"Types..."}
            styles={customStyles}
            components={{
              DropdownIndicator: () => (
                <IoChevronDown className="cursor-pointer" size={20} />
              ),
            }}
            onChange={(value) => {
              setDataStep2((prev) => ({
                ...prev,
                local_shareholding_hold: value,
                local_shareholding: value.value,
              }));
            }}
          />
        </div>
      </div>
      <div className="flex justify-between">
        <ButtonNew
          variant={"ghost"}
          btnPadding={"px-0 py-0"}
          onClick={() => {
            // HandleOnChangeStep();
            setStep((prev) => prev - 1);
          }}
          btnColor={"text-bbc-neutral-600 hover:text-bbc-neutral-700"}
        >
          Back
        </ButtonNew>
        <ButtonNew
          disabled={
            companyNameRef.current?.value?.length == 0 ||
            registered === null ||
            Object.keys(dataStep2).length < 8 ||
            !dataStep2.hasOwnProperty("years_operation") ||
            !dataStep2.hasOwnProperty("local_shareholding")
          }
          variant={"ghost"}
          btnPadding={"px-0 py-0"}
          othersClass={styles.disabledBtn}
          onClick={() => {
            // HandleOnChangeStep();
            setStep((prev) => prev + 1);
          }}
        >
          Next
        </ButtonNew>
      </div>
    </>
  );
}

export default Step2;
